import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { settingsKeys } from 'core/query-client/keys/settings.keys';
import { executeRequest } from 'core/utils/backend-service';
import { getPocFields, POCFieldAttribute } from 'modules/settings/pods/settings-integrations/service';

export const useFetchPocFields = () => {
    const { data: pocFields = [], isFetching } = usePocQuery<POCFieldAttribute[]>({
        queryKey: settingsKeys.lmsPocFields(),
        queryFn: () => executeRequest(() => getPocFields()),
    });

    return { pocFields, isFetching };
};
